import {Component, HostListener, OnInit} from '@angular/core';
import {ApplicationService} from "../../services/application.service";
import {MenuService} from "../../services/menu.service";
import {Router} from "@angular/router";
import {ConfirmationService} from "primeng/api";
import {TranslocoService} from '@ngneat/transloco';
import {Application} from "../../model/application";
import {SortOrder} from "../../model/sort-order";
import {AuthGuard} from "../../common/auth-guard.service";
import {TimezoneService} from "../../services/timezone.service";
import {ApplicationFilters} from "../../model/filters/application-filters";
import {CommonMessagesService} from "../../services/common-messages.service";
import {FiltersService} from "../../services/filters.service";

@Component({
  selector: 'app-application',
  templateUrl: './applications.component.html',
  styleUrls: ['./applications.component.scss']
})
export class ApplicationsComponent implements OnInit {

  public applications: Application[];
  public totalApplications: number;
  public loadingApplications: boolean;

  public rows = 10;
  public first = 0;
  public selected = [];

  private CURRENT_SORTFIELD = "code";

  public filtersVisible: boolean;
  public currentFilters: ApplicationFilters;

  public color: string;
  public filtersFilled: boolean;

  constructor(private menuService: MenuService,
              private applicationService: ApplicationService,
              private router: Router,
              private commonMessagesService: CommonMessagesService,
              private translocoService: TranslocoService,
              private confirmationService: ConfirmationService,
              private timezoneService: TimezoneService,
              public authGuardService: AuthGuard,
              private filtersService: FiltersService<ApplicationFilters>) {
    this.currentFilters = new ApplicationFilters();
  }

  ngOnInit(): void {
    if (this.filtersService.getCurrentFilters(this.constructor.name) !== undefined) {
      this.filtersFilled = true;
    }
    Object.assign(this.currentFilters, this.filtersService.getCurrentFilters(this.constructor.name));
    this.applications = new Array(this.rows);
  }

  private loadApplications(offset: number, limit: number){
    this.loadingApplications = true;
    this.applications = new Array(this.rows);
    this.trimFieldsForm(this.currentFilters);
    this.applicationService.getApplications(offset, limit, this.filtersService.getCurrentFilters(this.constructor.name) === undefined ? this.currentFilters: this.filtersService.getCurrentFilters(this.constructor.name)).subscribe(response =>{
      this.applications = response.applications;
      this.totalApplications = response.totalElements;
      this.loadingApplications = false;
    });
  }

  onPageChange(event) {
    this.currentFilters.sortField = event.sortField;
    this.CURRENT_SORTFIELD = event.sortField;
    this.currentFilters.sortOrder = event.sortOrder < 0 ? SortOrder.DESCENDING : SortOrder.ASCENDING;
    this.loadApplications(event.first/event.rows, event.rows);
  }

  resetFilters() {
    this.currentFilters = new ApplicationFilters();
    this.currentFilters.sortField = this.CURRENT_SORTFIELD;
    this.filtersFilled = false;
    this.filtersService.setCurrentFilters(undefined, this.constructor.name);
    this.applyFilters(true);
  }

  applyFilters(reset?: boolean) {
    this.first = 0;
    if (reset !== true){
      this.filtersService.setCurrentFilters(this.currentFilters, this.constructor.name);
      this.filtersFilled = true;
    }
    this.loadApplications(this.first/this.rows, this.rows);
  }

  confirmAndDelete(application: Application) {
    this.commonMessagesService.showDeleteRequestConfirmation(() => {
      this.deleteApplication(application.uuid);
    });
  }

  deleteApplication(uuid: string) {
    this.applicationService.deleteApplication(uuid).toPromise().then(() => {
      this.commonMessagesService.showSuccessfullyDeletedMessage();
      this.loadApplications(this.first/this.rows, this.rows);
    }, error => {
      this.commonMessagesService.showErrorWhileDeletingMessage(error.status);
    })
  }

  trimFieldsForm(filters: ApplicationFilters) {
    Object.keys(filters).forEach((key)=> {
      if (filters[key] != undefined && typeof filters[key] === 'string') {
        filters[key] = filters[key].trim();
      }
    });
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if(event.key === 'f'){
      this.filtersVisible = true;
    }
    if(event.key === 'Escape'){
      this.filtersVisible = false;
    }
  }

}
